import { useDispatch, useSelector } from "react-redux";
import AsyncSelect from 'react-select/async';
import Action from "../redux/Action";
import { setFormValue } from "../redux/Reducer";

const SelectShipper = () => {
  const dispatch = useDispatch();

  const errors = useSelector((state) => state.reducer.errors);
  const formValue = useSelector((state) => state.reducer.formValue);

  const loadOptions = async (inputValue) => {
    try {
      const response = await Action.getShipperList({
        search: inputValue.toLowerCase(),
      });
      return response;
    } catch (error) {
      console.error("Error loading options:", error);
      return [];
    }
  };
  return (
    <AsyncSelect
      styles={{
        control: (baseStyles) => ({
          ...baseStyles,
          borderRadius: "12px",
          borderColor: errors.shipmentProvider ? "red" : "transparent",
        }),
      }}
      cacheOptions
      defaultOptions
      name="shipmentProvider"
      className={`text-sm bg-white font-medium rounded-xl w-full ${errors.shipmentProvider ? "border-red-500" : ""}`}
      loadOptions={loadOptions}
      value={formValue?.shipmentProvider}
      onChange={(item) => {
        dispatch(
          setFormValue({
            ...formValue,
            shipmentProvider: item,
          }),
        );
      }}
    />
  );
};

export default SelectShipper;
